import { useQuery } from "@tanstack/react-query";

import { getOperatorsByQuery } from "@/v2/service/operatorsService";

import { useOperatorsSelectParams } from "./useOperatorsSelectParams";

export const useOperatorsSelectQuery = () => {
  const query = useOperatorsSelectParams((state) => state.query);

  return useQuery(["operators-select-query", query], () => getOperatorsByQuery(`?${query}`), {
    select: ({ data }) => data,
    enabled: Boolean(query),
  });
};
